import { render, staticRenderFns } from "./ExpensesScreen.vue?vue&type=template&id=6a2991e5&scoped=true&"
import script from "./ExpensesScreen.vue?vue&type=script&lang=js&"
export * from "./ExpensesScreen.vue?vue&type=script&lang=js&"
import style0 from "./ExpensesScreen.vue?vue&type=style&index=0&id=6a2991e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2991e5",
  null
  
)

export default component.exports